import { configureStore } from '@reduxjs/toolkit';
import authReducer from './auth/authSlice.ts';
import userReducer from './user/userSlice.ts';
import organizationReducer from './organization/organizationSlice.ts';
import apiKeyReducer from './apiKey/apiKeySlice.ts';
import tmActorReducer from '../modules/threatModeling/store/tmActor/tmActorSlice.ts';
import tmMitigationReducer from '../modules/threatModeling/store/tmMitigation/tmMitigationSlice.ts';
import tmRiskReducer from '../modules/threatModeling/store/tmRisk/tmRiskSlice.ts';
import tmAssessmentReducer from '../modules/threatModeling/store/tmAssessment/tmAssessmentSlice.ts';
import doraGeneralInfoReducer from '../modules/dora/store/generalInfo/generalInfoSlice.ts';
import doraFinancialEntityReducer from '../modules/dora/store/financialEntity/financialEntitySlice.ts';
import doraBusinessServiceReducer from '../modules/dora/store/businessService/businessServiceSlice.ts';
import doraICTThirdPartyProviderReducer from '../modules/dora/store/ictThirdPartyProvider/ictThirdPartyProviderSlice.ts';
import doraICTServiceReducer from '../modules/dora/store/ictService/ictServiceSlice.ts';
import doraControlReducer from '../modules/dora/store/control/controlSlice.ts';
import doraRiskReducer from '../modules/dora/store/risk/riskSlice.ts';
import doraIncidentReducer from '../modules/dora/store/incident/incidentSlice.ts';
import doraTestingExerciseReducer from '../modules/dora/store/testingExercise/testingExerciseSlice.ts';
import doraFindingReducer from '../modules/dora/store/finding/findingSlice.ts';
import doraContractualArrangementReducer from '../modules/dora/store/contractualArrangement/contractualArrangementSlice.ts';
import doraContractualArrangementDetailReducer from '../modules/dora/store/contractualArrangementDetail/contractualArrangementDetailSlice.ts';
import doraFunctionReducer from '../modules/dora/store/function/functionSlice.ts';
import doraIctServiceAssessmentReducer from '../modules/dora/store/ictServiceAssessment/ictServiceAssessmentSlice.ts';

export const store = configureStore({
    reducer: {
        auth: authReducer,
        user: userReducer,
        organization: organizationReducer,
        apiKey: apiKeyReducer,
        tmActor: tmActorReducer,
        tmMitigation: tmMitigationReducer,
        tmRisk: tmRiskReducer,
        tmAssessment: tmAssessmentReducer,
        doraGeneralInfo: doraGeneralInfoReducer,
        doraFinancialEntity: doraFinancialEntityReducer,
        doraBusinessService: doraBusinessServiceReducer,
        doraFunction: doraFunctionReducer,
        doraICTThirdPartyProvider: doraICTThirdPartyProviderReducer,
        doraICTService: doraICTServiceReducer,
        doraControl: doraControlReducer,
        doraRisk: doraRiskReducer,
        doraIncident: doraIncidentReducer,
        doraTestingExercise: doraTestingExerciseReducer,
        doraFinding: doraFindingReducer,
        doraContractualArrangement: doraContractualArrangementReducer,
        doraContractualArrangementDetail: doraContractualArrangementDetailReducer,
        doraIctServiceAssessment: doraIctServiceAssessmentReducer,
    }
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export default store;
